import { render, staticRenderFns } from "./BlogPrevNext.vue?vue&type=template&id=758646d4"
import script from "./BlogPrevNext.vue?vue&type=script&lang=js"
export * from "./BlogPrevNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports